
















































































































































































































import Vue from 'vue'
import LoadingOverlay from '@/components/atoms/LoadingOverlay.vue'
import variables from '@/scss/variables.scss'
import { Learner } from 'vue/types/vue'
import Pill from '@/components/atoms/Pill.vue'
import RemoveIcon from '@/assets/svgs/x_close_icon.svg?inline'
import FilterSearch from '@/components/search/FilterSearch.vue'
import LearnerInfo from '@/components/search/searchResults/LearnerInfo.vue'
import CandidateDrawer from '@/components/search/searchResults/CandidateDrawer.vue'
import Dropdown from '@/components/atoms/Dropdown.vue'
import NoSearchResultsIcon from '@/assets/svgs/no_search_results.svg?inline'
import { GET_CANDIDATES_WITH_MATCHING_PROGRAM_QUERY, GET_CANDIDATES_WITH_MATCHING_SKILL_QUERY } from '@/graphql'

interface Data {
  currentLearner: Learner
  isCandidateDrawerOpen: boolean
  isFilterDrawerOpen: boolean
  isLoading: boolean
  hasDatabaseError: boolean
  learnerResults: Learner[]
  potentialCandidatesWithMatchingSkills: Learner[]
  needsExternship: false
  learnerSortOptions: typeof Vue.Constants.LEARNER_SORT_OPTIONS
  sortBy: string
  savedFilters: {
    id: number
    name: string
  }[]
}
interface Methods {
  windowResized: () => void
  setCurrentLearner: (learner: Learner) => void
  closeCandidateDrawer: () => void
  handleSearchError: (err) => void
  executeSearch: () => void
}

interface Computed {}

interface Props {}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'SearchResults',
  created () {
    window.addEventListener('resize', this.windowResized)
  },
  destroyed () {
    window.removeEventListener('resize', this.windowResized)
  },
  data: () => ({
    currentLearner: {} as Learner,
    isCandidateDrawerOpen: false,
    isFilterDrawerOpen: false,
    isLoading: true,
    hasDatabaseError: false,
    learnerResults: [] as Learner[],
    potentialCandidatesWithMatchingSkills: [] as Learner[],
    needsExternship: false,
    learnerSortOptions: Vue.Constants.LEARNER_SORT_OPTIONS,
    sortBy: 'Number of Badges',
    savedFilters: [
      {
        id: 1,
        name: 'Dental Assistant Search'
      },
      {
        id: 2,
        name: 'Hemodialysis Skills'
      },
      {
        id: 3,
        name: 'Hemodialysis Technician Search'
      },
      {
        id: 4,
        name: 'Medical Assistant and Hemodialysis'
      },
      {
        id: 5,
        name: 'Patient Care Fundamentals + Hemodialysis Skills'
      },
      {
        id: 6,
        name: 'Patient Care Technician Search'
      }
    ]
  }),
  props: {
    cityOrZip: String,
    programOrSkill: String,
    searchType: String,
    distance: String
  },
  components: {
    LoadingOverlay,
    LearnerInfo,
    Dropdown,
    NoSearchResultsIcon,
    FilterSearch,
    Pill,
    RemoveIcon,
    CandidateDrawer
  },
  methods: {
    windowResized () {
      if (window.outerWidth >= variables.xl) {
        this.isFilterDrawerOpen = false
      }
      if (window.outerWidth < variables.lg) {
        this.closeCandidateDrawer()
      }
    },
    setCurrentLearner (learner: Learner) {
      if (window.outerWidth >= variables.lg) {
        this.currentLearner = learner
        this.isCandidateDrawerOpen = true
      }
    },
    closeCandidateDrawer () {
      this.isCandidateDrawerOpen = false
      this.currentLearner = {} as Learner
    },
    handleSearchError: function (error) {
      console.log(error)
      this.isLoading = false
      this.hasDatabaseError = true
      this.$emit('showDatabaseErrorMessage', true)
    },
    executeSearch: async function () {
      this.isLoading = true
      this.learnerResults = []
      this.potentialCandidatesWithMatchingSkills = []
      this.hasDatabaseError = false
      if (this.$route.query.searchType === 'program') {
        await this.$apollo.query({
          query: GET_CANDIDATES_WITH_MATCHING_PROGRAM_QUERY,
          variables: {
            location: this.$route.query.location,
            program: this.$route.query.program
          }
        }).then((response) => {
          let allLearnersWithPercentSkillsMatch = response.data.getCandidatesWithMatchingProgram.candidates.map((candidate, index) => ({
            ...candidate,
            percentSkillsMatch: response.data.getCandidatesWithMatchingProgram.percentSkillsMatch[index]
          }))
          this.learnerResults = allLearnersWithPercentSkillsMatch.filter(
            (candidate) => candidate.program === this.$route.query.program
          )
          this.potentialCandidatesWithMatchingSkills = allLearnersWithPercentSkillsMatch.filter(
            (candidate) => candidate.program !== this.$route.query.program
          )
        }).catch((error) => {
          this.handleSearchError(error)
        })
      } else if (this.$route.query.searchType === 'skill') {
        await this.$apollo.query({
          query: GET_CANDIDATES_WITH_MATCHING_SKILL_QUERY,
          variables: {
            location: this.$route.query.location,
            skill: this.$route.query.program
          }
        }).then((response) => {
          this.learnerResults = response.data.getCandidatesWithMatchingSkill.candidates.map((candidate, index) => ({
            ...candidate,
            percentSkillsMatch: response.data.getCandidatesWithMatchingSkill.percentSkillsMatch[index]
          }))
        }).catch((error) => {
          this.handleSearchError(error)
        })
        this.potentialCandidatesWithMatchingSkills = []
      } else {
        // Filter search is not set up yet
      }
      this.$emit('showDatabaseErrorMessage', this.hasDatabaseError)
      this.isLoading = false
    }
  },
  mounted: function () {
    (this! as Methods).executeSearch()
  },
  beforeDestroy () {
    this.hasDatabaseError = false
    this.$emit('showDatabaseErrorMessage', this.hasDatabaseError)
  },
  watch: {
    '$route.query': function () {
      (this! as Methods).executeSearch()
    }
  }
})
